import { Button, Spacer, Text, TextField } from '@truepill/react-capsule'
import CloseButton from 'components/CloseButton'
import styled from 'styled-components'
import type { Condition, Rule } from '../CreateRuleSetPage'
import ConditionCard from './ConditionCard'

const RuleCard = ({
  index,
  rule,
  onRuleChange,
  onConditionChange,
  onAddCondition,
  onRemoveCondition,
  attemptedSubmit,
  onRemoveRule,
}: {
  index: number
  rule: Rule
  onRuleChange: (field: keyof Rule, value: any) => void
  onConditionChange: (condIdx: number, field: keyof Condition, value: any) => void
  onAddCondition: () => void
  onRemoveCondition: (condIdx: number) => void
  attemptedSubmit: boolean
  onRemoveRule?: () => void
}) => {
  return (
    <Container key={index}>
      <TextField
        label="Rule Name"
        value={rule.name}
        onChange={e => onRuleChange('name', e.target.value)}
        state={attemptedSubmit && !rule.name ? 'error' : 'default'}
        helperText={attemptedSubmit && !rule.name ? 'Name is required' : undefined}
      />
      <Spacer size="md" />
      <TextField
        label="Rule Description (optional)"
        value={rule.description}
        onChange={e => onRuleChange('description', e.target.value)}
      />
      <Spacer size="lg" />
      <Text as="h4">Conditions</Text>
      <Text as="p" variant="caption">
        You can add as many conditions as you want, have in mind that all the conditions have to be satisfied at the
        same time in order to route an order to this location
      </Text>
      <Spacer size="md" />
      {rule.conditions.map((cond, condIdx) => (
        <ConditionCard
          index={condIdx}
          cond={cond}
          onChange={(field, value) => onConditionChange(condIdx, field, value)}
          attemptedSubmit={attemptedSubmit}
          onRemove={rule.conditions.length > 1 ? () => onRemoveCondition(condIdx) : undefined}
        />
      ))}
      <Spacer size="sm" />
      <Button size="xs" type="button" variant="primary-text" onClick={onAddCondition}>
        Add Condition
      </Button>
      {onRemoveRule && <CloseButton size="0.7rem" contrast clickCallback={onRemoveRule} />}
    </Container>
  )
}

const Container = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  margin: 1.5rem 0;
  padding: 1.5rem;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
  position: relative;
`

export default RuleCard
